import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import TabPage from "./../../../factories/tab-page";

/**
 * Class to represent the ViewModel of the ImageResize-Dialog.
 */
class ImageResizeDialog {
	Bao = Bao;

	//#region Constructors
	/**
	 * Initializes a new instance of the ImageResizeDialog class.
	 * @param imageSize The original imagesize of the given image.
	 */
	constructor(imageSize: { height: number, width: number }) {

		this.MaxImageSize = imageSize !== null ? Math.max(imageSize.height, imageSize.width) : 1024;

		if (this.MaxImageSize > 640) {
			this.SelectedImageSize("Medium");
		}
		else if (this.MaxImageSize > 320) {
			this.SelectedImageSize("Small");
		}
		else {
			this.SelectedImageSize("Logo");
		}
	}

	//#endregion

	//#region Properties

	/**
	 * Gets or sets the current selected target image size.
	 */
	private SelectedImageSize: KnockoutObservable<string> = ko.observable<string>("Medium");

	/**
	 * Gets or sets the current selected target image type.
	 */
	private SelectedImageFormat: KnockoutObservable<string> = ko.observable<string>("webp");

	/**
	 * Gets or sets the size of the largest side of the original image.
	 */
	private MaxImageSize: number;

	//#endregion

	//#region Public Methods

	//Perform image resize
	ImageResize = (imageSrc:any, callback) => {

		// if it's a base64string 
		if (typeof (imageSrc) === 'string') {
			this.PerformImageResize(imageSrc, (base64String) => {
				callback(base64String);
			});
		}
		else {
			// else it's a file object 
			let fileReader = new FileReader();
			fileReader.onload = () => {
				this.PerformImageResize(fileReader.result, (base64String) => {
					callback(base64String);
				});
			}
			fileReader.readAsDataURL(imageSrc);
		}
	}

	//#endregion

	//#region Private Methods

	//Perform image resize using Web API
	private PerformImageResize = (base64String:any, callback)  => {
		let tabPage = new TabPage();

		if (this.SelectedImageSize() == 'Original') {
			callback(base64String);
			return;
		}

		let imageDetail = JSON.stringify({
			ImageBase64str: base64String,
			ImageTargetSize: this.SelectedImageSize(),
			TargetFileFormat: this.SelectedImageFormat()
		});

		tabPage.IsLoading(true);
		Bao.post("Checkware/ChecklistManager/PerformImageResize", imageDetail, (result) => {
			tabPage.IsLoading(false);
			if (result) {
				callback(result.image);
			}
		});
	}

	//#endregion
}
export default ImageResizeDialog;